import React, { Component } from 'react';
export default class Header extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <React.Fragment>

        <header id="home">
          <nav id="nav-wrap">
            <a className="mobile-btn" href="#nav-wrap" title="Show navigation">Show navigation</a>
            <a className="mobile-btn" href="#" title="Hide navigation">Hide navigation</a>
            <ul id="nav" className="nav">
              <li className="current"><a className="smoothscroll" href="#home">Home</a></li>
              {/* <li><a className="smoothscroll" href="#about">About</a></li> */}
              {/* <li><a className="smoothscroll" href="#resume">Resume</a></li>
              <li><a className="smoothscroll" href="#portfolio">Works</a></li>
              <li><a className="smoothscroll" href="#testimonials">Testimonials</a></li> */}
              <li><a className="smoothscroll" href="#contact">Contact</a></li>
            </ul>
          </nav>

          <div className="row banner">
              <div className="banner-text">
              <img style={{height:100,width:100,  borderRadius: 100}} src="images/logo.png" alt="" />
              <h1 className="responsive-headline">AlphaY</h1>
              <h3 style={{ color: '#fff', fontFamily: 'sans-serif ' }}>Welcome to AlphaY, where we specialize in creating cutting-edge mobile applications that enhance user experiences and drive business success.
              </h3>
              {/* <hr />
              <ul className="social">
                {
                  resumeData.socialLinks && resumeData.socialLinks.map(item => {
                    return (
                      <li key={item.name}>
                        <a href={item.url} target="_blank"><i className={item.className}></i></a>
                      </li>
                    )
                  }
                  )
                }
              </ul> */}
            </div>
          </div>

          {/* <p className="scrolldown">
            <a className="smoothscroll" href="#about"><i className="icon-down-circle"></i></a>
          </p> */}

        </header>
      </React.Fragment>
    );
  }
}